/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
/**
 * This module allows custom configuration for components.
 */
const customConfig = globalThis["calciteConfig"];
const focusTrapStack = customConfig?.focusTrapStack || [];
const version = "2.10.1"; // version number is set by build
/**
 * Stamp the version onto the global config.
 */
function stampVersion() {
    if (customConfig && customConfig.version) {
        console.warn(`[calcite-components] while initializing v${version}, an existing configuration with version "${customConfig.version}" was found. This may cause unexpected behavior. The version will not be added to the existing global configuration.`);
        return;
    }
    const target = customConfig || globalThis["calciteConfig"] || {};
    Object.defineProperty(target, "version", {
        value: version,
        writable: false,
    });
    globalThis["calciteConfig"] = target;
}

export { focusTrapStack as f, stampVersion as s };

//# sourceMappingURL=config-cdc3bb2b.js.map